import 'react';
import { useSaucerSelector } from '../context';
/**
 * Get All Available Cups Name from Context
 */
export function useAvailableCupsName() {
    var cups = useSaucerSelector(function (state) { return state.cups.availableCup; });
    return cups !== null && cups !== void 0 ? cups : [];
}
